const SVGComponent = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		viewBox="0 0 1024 1024"
		aria-label="Weinberg Logo"
		role="img"
		{...props}
	>
		<path d="M206 136v752h611V136H206zm585 376v349H233V162h558v350z" />
		<path d="M276 258v43h9c9 0 10 0 10 2l1 177v174l6 7a4285 4285 0 0 0 105 122c18 21 20 23 21 21a51031 51031 0 0 0 85-291l11 38 41 146 32 109 6-7 100-116 19-22 6-7V301h20v-86H632v221l-1 221-2-12-21-76-44-165-28-106-2-6h-44l-9 33-17 62-63 237-8 32-1-220V215H276v43z" />
	</svg>
);
export default SVGComponent;
